import React from "react";
import { Chip } from "./Chip";

/**
 * Persistent project header — V3 §8 pattern.
 * @param {Object} props
 * @param {string} props.name
 * @param {string} props.address
 * @param {string} props.stage
 * @param {string} props.health
 * @param {string} props.pm
 * @param {string} props.superintendent
 * @param {string} props.contractValue
 * @param {string} [props.nextMilestone]
 * @param {string} [props.nextAction]
 */
export function ProjectHeader({
  name, address, stage, health, pm, superintendent,
  contractValue, nextMilestone, nextAction,
}) {
  return (
    <div className="ds-project-header">
      <div>
        <div className="ds-ph-title">{name}</div>
        <div className="ds-ph-address">{address}</div>
        <div className="ds-chip-row" style={{ marginTop: 10 }}>
          {stage && <Chip status="pending">{stage}</Chip>}
          {health && <Chip status="live">Health · {health}</Chip>}
        </div>
        <div className="ds-ph-meta">
          {pm && <div><div className="label">Project manager</div><div className="value">{pm}</div></div>}
          {superintendent && <div><div className="label">Superintendent</div><div className="value">{superintendent}</div></div>}
          {nextMilestone && <div><div className="label">Next milestone</div><div className="value">{nextMilestone}</div></div>}
        </div>
      </div>
      <div className="ds-ph-side">
        <div className="type-caption">Contract value</div>
        <div className="ds-ph-value-big">{contractValue}</div>
        {nextAction && (
          <>
            <div className="type-small" style={{ marginTop: 12 }}>Next action</div>
            <div style={{ fontSize: 13, marginTop: 2 }}>{nextAction}</div>
          </>
        )}
      </div>
    </div>
  );
}
